<template>
  <div class="container_inner pd">
    <div class="title">
      <h3>
        PERSONALIZE SEU LADRILHO
      </h3>
      <h2>
        {{passo == 1 ? 'ESCOLHA O MODELO, O FORMATO, O LADRILHO E AS CORES' : 'ESCOLHA A COR DO REJUNTE'}}
      </h2>
    </div>
    <Filter :style="passo == 1 ? 'display:flex' : 'display:none'" @changeLadrilho="changeLadrilho"></Filter>
    <Passo01 :style="passo == 1 ? 'display:block' : 'display:none'" :ladrilho="ladrilho" @changePasso="ChangePasso"  @corUtil="corUtil"></Passo01>
    <Passo02 v-if="passo == 2" :ladrilho="ladrilho" @changePasso="ChangePasso" :cores-utilizadas="coresUtilizadas"></Passo02>
  </div>
</template>

<script>
import Filter from './components/Filter.vue'
import Passo01 from "@/components/Passo01";
import Passo02 from "@/components/Passo02";

export default {
  name: 'App',
  data() {
    return {
      ladrilho: '',
      cor: '',
      passo: 1,
      coresUtilizadas: [],
      urlSvg: process.env.VUE_APP_SVG,
    }
  },
  mounted() {
    console.log(this.api);
  },
  methods: {
    changeLadrilho(value) {
      this.ladrilho = value;
    },

    corUtil(emit) {
      this.coresUtilizadas = emit;
    },

    ChangePasso(value) {
      this.passo = value;
    }
  },
  components: {
    Filter,
    Passo01,
    Passo02,
  },
}
</script>

<style>
.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.gap-1 {
  gap: 25px;
}

.flex .col {
  flex: 1;
}

</style>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.pd {
  padding: 60px 0px;
}

.title h3 {
  text-align: center;
  font-weight: 200;
}

.title h2 {
  text-align: center;
}
</style>
<style>
@import 'vue-select/dist/vue-select.css';
</style>